export const REACT_APP_GOOGLE_KEY = process.env.REACT_APP_GOOGLE_KEY;
export const REACT_APP_WHAT3WORDS_KEY = process.env.REACT_APP_WHAT3WORDS_KEY;
export const REACT_APP_WHAT3WORDS_URL = process.env.REACT_APP_WHAT3WORDS_URL;
export const TOP_UP_URL = process.env.REACT_APP_PAYMENT_API;
export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const ADMIN_CLIENT_URL = process.env.REACT_APP_ADMIN_CLIENT_URL;
export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const GUEST_REQUEST_TOKEN = "eyJpdiI6Ii9oSjBJVDNuL3Nsbm1rdzZTM1ZZR1E9PSIsInZhbHVlIjoiZXdveFJHZlpQcVRlUmlReVVGOWx3ZzIrbjRlTGhoWWNKOEFpMTRqb2xrWT0iLCJtYWMiOiIxOWZhNDJlMTJjN2Q3YTI2M2I2MmIwNzMyYjZlMjk5YWFhMmM4YzkxZjk5MDdkNzJhMTY1YjQ2ODgwYzRlZjJkIiwidGFnIjoiIn0=";